import * as React from 'react';
import { Grid } from '@mui/material';
import { Dialog } from '.';;

interface Props {
  id?: string;
  label?: string;
  disable?: boolean;
  children?: React.ReactNode;
}

export const ScreenGuard: React.FunctionComponent<Props> = (props) => {;
  const [open, setOpen] = React.useState(false);
  const sx ={webkitTouchCallout: 'none', webkitUserSelect: 'none', khtmlUserSelect: 'none', mozUserSelect: 'none', msUserSelect: 'none', userSelect: 'none'}

  const onKeydownEvent = React.useCallback(async (e: KeyboardEvent) => {
    if ((e.shiftKey && e.metaKey) || (e.key==='PrintScreen')) 
      setOpen(true);
  }, []);
  
  const onClipboardEvent = React.useCallback((e: ClipboardEvent) => { 
    e.preventDefault() ;
  }, []);  
  
  const onMouseEvent = React.useCallback((e: MouseEvent) => {
    setOpen(false); 
    e.type==='contextmenu' && e.preventDefault();
  }, []);
  
  const onBlurEvent = React.useCallback((e: FocusEvent) => {
      if(document.activeElement?.tagName === 'IFRAME') 
        setTimeout(()=> window.focus(), 1); 
      else 
        setOpen(true);
  }, []);
  
  const onFocusEvent = React.useCallback((e: FocusEvent) => {
    setOpen(false)
  }, []);  
  
  React.useEffect(() => { 
    if (props.disable) return;
    
    document.addEventListener('copy', onClipboardEvent);
    document.addEventListener('cut', onClipboardEvent);
    window.addEventListener('keydown', onKeydownEvent);
    window.addEventListener('click', onMouseEvent);
    window.addEventListener('contextmenu', onMouseEvent);
    window.addEventListener('blur', onBlurEvent);
    window.addEventListener('focus', onFocusEvent);
    
    return () => {
      document.removeEventListener('copy', onClipboardEvent);
      document.removeEventListener('cut', onClipboardEvent);
      window.removeEventListener('keydown', onKeydownEvent);
      window.removeEventListener('click', onMouseEvent)
      window.removeEventListener('contextmenu', onMouseEvent)
      window.removeEventListener('blur', onBlurEvent);
      window.removeEventListener('focus', onFocusEvent);
    }
  }, [props.disable])

  /*
  ##useEffect rules:
  useEffect( () => console.log('mount'), [] );
  useEffect( () => console.log('data1 update'), [ data1 ] );
  useEffect( () => console.log('any update') );
  useEffect( () => () => console.log('data1 update or unmount'), [ data1 ] );
  useEffect( () => () => console.log('unmount'), [] );
  */
  
  return (
    <Grid sx={{...(!props.disable && sx), opacity: open? 0.1 : 1}}>
      {open? <Grid>{props.children}</Grid> : props.children}
      <Dialog open={open} maxWidth='xs'>  
          {props.label || 'Screen was temporary locked, please click anywere.'}
      </Dialog>
    </Grid>
    )
}
